export const mergedQueryParams = (key: string, value: string) => {
  const params = new URLSearchParams(window.location.search);

  if (value) {
    params.set(key, value);
  } else {
    params.delete(key);
  }
  params.delete("page");

  return Object.fromEntries(params);
};
